/* eslint-disable consistent-return */
/* eslint-disable no-console */
import t from './SystemMasters.type';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import {
  getAllSizeRanges,
  createSizeRange,
  updateSizeRange,
  deleteSizeRange,
  createSizeInRangeMaster,
  updateSizeInRangeMaster,
  deleteSizeInRangeMaster,
  bulkSaveSizeRanges,
} from '../../../services/sizeRange.service';
import { ERROR_MESSAGE } from '../../../Components/helper';

export const getSizeRangesMasterDetails = (params) => async (dispatch) => {
  try {
    const res = await getAllSizeRanges(params);
    let payload = [];
    if (Array.isArray(res?.data)) {
      payload = res.data;
    } else if (Array.isArray(res?.data?.data)) {
      payload = res.data.data;
    } else {
      payload = [];
    }
    await dispatch({
      type: t.GET_ALL_SIZE_RANGES_MASTER,
      payload,
    });
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const createSizeRangeMaster = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await createSizeRange(params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('SIZE_RANGE_MASTER.TOASTS.RANGE_CREATED'), 'success');
      await dispatch(getSizeRangesMasterDetails({ loggedInUserId: params.loggedInUserId }));
      return res.data;
    }
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  }
};

export const updateSizeRangeMaster = (sizeRangeId, params, transactionMsg) => async (dispatch) => {
  try {
    const res = await updateSizeRange(sizeRangeId, params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('SIZE_RANGE_MASTER.TOASTS.RANGE_UPDATED'), 'success');
      await dispatch(getSizeRangesMasterDetails({ loggedInUserId: params.loggedInUserId }));
      return res.data;
    }
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  }
};

export const deleteSizeRangeMaster = (sizeRangeId, params, transactionMsg) => async (dispatch) => {
  try {
    const res = await deleteSizeRange(sizeRangeId, params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('SIZE_RANGE_MASTER.TOASTS.RANGE_DELETED'), 'success');
      await dispatch(getSizeRangesMasterDetails({ loggedInUserId: params.loggedInUserId }));
      return res.data;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(`${res?.data?.errMsg}`), 'danger');
      return null;
    }
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  }
};

export const createSizeInRange = (sizeRangeId, params, transactionMsg) => async (dispatch) => {
  try {
    const res = await createSizeInRangeMaster(sizeRangeId, params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('SIZE_RANGE_MASTER.TOASTS.SIZE_CREATED'), 'success');
      await dispatch(getSizeRangesMasterDetails({ loggedInUserId: params.loggedInUserId }));
      return res.data;
    }
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  }
};

export const updateSizeInRange = (sizeRangeId, sizeId, params, transactionMsg) => async (dispatch) => {
  try {
    const res = await updateSizeInRangeMaster(sizeRangeId, sizeId, params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(`SIZE_RANGE_MASTER.${res.message}`), 'success');
      await dispatch(getSizeRangesMasterDetails({ loggedInUserId: params.loggedInUserId }));
      return res.data;
    }
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  }
};

export const deleteSizeInRange = (sizeRangeId, sizeId, params, transactionMsg) => async (dispatch) => {
  try {
    const res = await deleteSizeInRangeMaster(sizeRangeId, sizeId, params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(`SIZE_RANGE_MASTER.${res.message}`), 'success');
      await dispatch(getSizeRangesMasterDetails({ loggedInUserId: params.loggedInUserId }));
      return res.data;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(`${res?.data?.errMsg}`), 'danger');
      return null;
    }
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  }
};
export const bulkSaveSizeRangesMaster = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await bulkSaveSizeRanges(params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(`SIZE_RANGE_MASTER.${res.message}`), 'success');
      await dispatch(getSizeRangesMasterDetails({ loggedInUserId: params.loggedInUserId }));
      return res.data;
    }
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
